module.exports = __webpack_public_path__ + "static/Sporcle-843cc57f6b60d15137d31c853d89ac0c.png";